module.exports = __webpack_public_path__ + "teikeibun.no4.d4817cd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/teikeibun.no4.jpg
// module id = aY+u
// module chunks = 0